"use strict";
const toggleIframeDisplay = (selector, display) => {
  const iframe = document.querySelector(selector);
  if (iframe) {
    iframe.style.display = display;
  }
};
const hideMessagingIframes = () => {
  toggleIframeDisplay("iframe#launcher", "none");
  toggleIframeDisplay('iframe[name="Messaging window"]', "none");
  toggleIframeDisplay('iframe[title="Number of unread messages"]', "none");
};
const restoreMessagingIframes = () => {
  toggleIframeDisplay("iframe#launcher", "");
  toggleIframeDisplay('iframe[title="Number of unread messages"]', "");
  toggleIframeDisplay('iframe[name="Messaging window"]', "");
};
export const restoreSupportChat = () => {
  restoreMessagingIframes();
};
const hideSupportChat = (drawer) => {
  hideMessagingIframes();
  if (!drawer) return;
  drawer.removeEventListener("opened-changed", openChangedEventListener);
  drawer.addEventListener("opened-changed", openChangedEventListener);
};
const openChangedEventListener = (event) => {
  if (event.detail.value == false) {
    restoreMessagingIframes();
  }
};
export { hideSupportChat };
